
define('text!templates/modules/calendar/calendar/calendar-component/item/item-delete-modal.html',[],function () { return '<p>{{#t}}messages:message-delete-activity{{/t}}</p>\n<div class="delete-session"></div>\n';});

